import { Menu2Icon } from "@/shared/icons";
import TransportWarehouseInfoCard from "@/domains/transportWarehouse/components/info/TransportWarehouseInfoCard";

type Props = { availiable: number; totalAvailiable: number };

export default function TransportWarehouseInfoCapacity({ availiable, totalAvailiable }: Props) {
  return (
    <TransportWarehouseInfoCard>
      <Menu2Icon size={24} className="text-accent-muted" />
      <div className="mt-auto text-20 font-bold text-white/50">
        <span className="text-accent-muted">{availiable}</span> / {totalAvailiable}
      </div>
      <div className="text-15 font-medium mt-2">Всего транспортных ячеек доступно</div>
    </TransportWarehouseInfoCard>
  );
}
